import EngineCard from './EngineCard';
import GuardrailsCard from './GuardrailsCard';
import JourneyTable from './JourneyTable';
import TransactionalCard from './TransactionalCard';
import useJourneys from './useJourneys';
import SectionState from '../shared/SectionState';

import SectionErrorBoundary from '@/routes/Agency/WorkerV2/components/SectionErrorBoundary';
import styled from '@/styles';

const Stack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  minWidth: 0,
});

const Frame = styled('div', {
  backgroundColor: '#FFFFFF',
  border: '1px solid #DADADA',
  borderRadius: '8px',
});

const JourneysTab = () => {
  const { data, loading, error, reload, refresh, updateJourney } =
    useJourneys();

  if (!data) {
    return (
      <Stack>
        <Frame>
          <SectionState
            error={error ?? undefined}
            mode={loading ? 'loading' : 'error'}
            title="engine"
            onRetry={reload}
          />
        </Frame>
      </Stack>
    );
  }

  return (
    <Stack>
      <SectionErrorBoundary label="the engine card">
        <EngineCard
          data={data}
          onRefresh={refresh}
          onSave={(changes) => updateJourney('_global', changes)}
        />
      </SectionErrorBoundary>
      <SectionErrorBoundary label="guardrails">
        <GuardrailsCard />
      </SectionErrorBoundary>
      <SectionErrorBoundary label="the journeys table">
        <JourneyTable journeys={data.journeys} onUpdate={updateJourney} />
      </SectionErrorBoundary>
      <SectionErrorBoundary label="transactional messages">
        <TransactionalCard messages={data.transactional} />
      </SectionErrorBoundary>
    </Stack>
  );
};

export default JourneysTab;
